module.exports = __webpack_public_path__ + "enable-autopilot-hero-c288e88bd32a482b325568219f7df2d1.png";